import React from "react";

import TimeCircleIcon from "../../../images/icons/time-circle.inline.svg";
import ShieldCheckIcon from "../../../images/icons/shield-check.inline.svg";
import IconStar from "../../../images/icons/star.inline.svg";
import CardPaymentIcon from "../../../images/icons/fi-rr-credit-card.inline.svg";

const StepNav = ({ tabHeading, currentStep, showPriceIcon = false }) => {
  return (
    <>
      {currentStep === 2 ? (
        <></>
      ) : (
        <div
          className={`${
            currentStep === 2 ? "bg-transparent" : "bg-white"
          } py-8 md:py-6 form-tab-heading dark:bg-gray-dark`}
        >
          <ul
            className={`flex flex-col justify-between gap-8 px-8 md:flex-row ${
              tabHeading && tabHeading?.length > 3 ? "md:gap-2" : "md:gap-20"
            } md:px-14`}
          >
            {tabHeading &&
              tabHeading.map((item, idx) => (
                <li
                  className={`flex items-start flex-col md:flex-row justify-start gap-3 ${
                    tabHeading.length === 2 ? "basis-1/2" : "basis-1/3"
                  }`}
                  key={idx}
                >
                  {item?.ico_star ? (
                    <IconStar className="h-4 w-4 fill-transparent stroke-black-lighter dark:stroke-gray-testimonial" />
                  ) : item?.ico_time ? (
                    <TimeCircleIcon className="h-4 w-4 fill-black-lighter dark:fill-gray-testimonial" />
                  ) : item?.ico_card ? (
                    <CardPaymentIcon className="h-4 w-4 fill-black-lighter dark:fill-gray-testimonial" />
                  ) : item?.ico_shield ? (
                    <ShieldCheckIcon className="h-4 w-4 fill-black-lighter dark:fill-gray-testimonial" />
                  ) : idx === 0 ? (
                    <ShieldCheckIcon className="h-4 w-4 fill-black-lighter dark:fill-gray-testimonial" />
                  ) : idx === 1 && showPriceIcon ? (
                    <CardPaymentIcon className="h-4 w-4 fill-black-lighter dark:fill-gray-testimonial" />
                  ) : (
                    <TimeCircleIcon className="h-4 w-4 fill-black-lighter dark:fill-gray-testimonial" />
                  )}
                  <div className="sm:pl-1 sm:-mt-[6px] text-black-lighter dark:text-gray-testimonial  w-full">
                    <div
                      className={`text-mob md:text-base dark:text-gray-septenary leading-app-step-nav-title font-normal`}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                    <div
                      className="text-xs dark:text-gray-darken leading-app-step-nav-subtitle font-normal"
                      dangerouslySetInnerHTML={{ __html: item.detail }}
                    />
                  </div>
                </li>
              ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default StepNav;
